import type { FluentCartCheckoutState } from '../../types/pifster-contracts';

export function needsLiveEligibilityResolution(
  state: FluentCartCheckoutState,
  loggedIn: boolean,
): boolean {
  return state.demoSession === null
    && state.mode === 'vote_plus_donate'
    && loggedIn
    && state.periodId !== null
    && state.charityId !== null;
}
